import React from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";
import { withRouter } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import {
  format,
  isSameDay,
  parse,
  isBefore,
  isAfter,
  isWithinInterval
} from "date-fns";
import qr from "../assets/images/blackberry.svg";
import hourglass from "../assets/images/hourglass.svg";
import hourglassOrange from "../assets/gifs/sandclock_orange.gif";
import hourglassWhite from "../assets/gifs/sandclock_white.gif";
import QR from "qrcode.react";
import AppBarAndDrawer from "../components/AppBarAndDrawer";
import { GET_12HR_TIME_FORMAT } from "../utils/CommonFunctions";

import CountdownTimer from "../components/Utils/CountdownTimer";
import { SLOT_PASS_COLORS } from "../utils/Colors";

import EmojiEmotionsTwoToneIcon from "@material-ui/icons/InsertEmoticon";

import BoardingImage from "../assets/images/Active Green.png";
import ActiveImage from "../assets/images/Current.png";
import UpcomingImage from "../assets/images/Upcoming.png";
import ExpiredImage from "../assets/images/Expired.png";

const styles = {
  container: {
    padding: "5%",
    // height: "calc(100vh - 70px)",
    height: "100%",
    marginTop: "25px",
    backgroundColor: "rgb(238, 238, 238)"
  },
  upcomingUpper: {
    padding: "20px",
    borderRadius: "10px",
    position: "relative",
    borderBottom: "2px dashed #e0e0e0",
    "&:after": {
      content: "''",
      width: " 25px",
      height: "25px",
      bottom: "-12px",
      backgroundColor: "rgb(238,238,238)",
      borderRadius: "15px",
      left: "-15px",
      position: "absolute",
      borderRight: `2px solid ${SLOT_PASS_COLORS.UPCOMING}`
    },
    "&:before": {
      content: "''",
      width: " 25px",
      height: "25px",
      bottom: "-12px",
      borderRadius: "15px",
      backgroundColor: "rgb(238,238,238)",
      right: "-15px",
      position: "absolute",
      borderLeft: `2px solid ${SLOT_PASS_COLORS.UPCOMING}`
    }
  },
  boardingUpper: {
    padding: "20px",
    borderRadius: "10px",
    position: "relative",
    borderBottom: "2px dashed #e0e0e0",
    "&:after": {
      content: "''",
      width: " 25px",
      height: "25px",
      bottom: "-12px",
      backgroundColor: "rgb(238,238,238)",
      borderRadius: "15px",
      left: "-15px",
      position: "absolute",
      borderRight: `2px solid ${SLOT_PASS_COLORS.BOARDING}`
    },
    "&:before": {
      content: "''",
      width: " 25px",
      height: "25px",
      bottom: "-12px",
      borderRadius: "15px",
      backgroundColor: "rgb(238,238,238)",
      right: "-15px",
      position: "absolute",
      borderLeft: `2px solid ${SLOT_PASS_COLORS.BOARDING}`
    }
  },
  activeUpper: {
    padding: "20px",
    borderRadius: "10px",
    position: "relative",
    borderBottom: "2px dashed #e0e0e0",
    "&:after": {
      content: "''",
      width: " 25px",
      height: "25px",
      bottom: "-12px",
      backgroundColor: "rgb(238,238,238)",
      borderRadius: "15px",
      left: "-15px",
      position: "absolute",
      borderRight: `2px solid ${SLOT_PASS_COLORS.ACIVE}`
    },
    "&:before": {
      content: "''",
      width: " 25px",
      height: "25px",
      bottom: "-12px",
      borderRadius: "15px",
      backgroundColor: "rgb(238,238,238)",
      right: "-15px",
      position: "absolute",
      borderLeft: `2px solid ${SLOT_PASS_COLORS.ACIVE}`
    }
  },
  expiredUpper: {
    padding: "20px",
    borderRadius: "10px",
    position: "relative",
    borderBottom: "2px dashed #e0e0e0",
    "&:after": {
      content: "''",
      width: " 25px",
      height: "25px",
      bottom: "-12px",
      backgroundColor: "rgb(238,238,238)",
      borderRadius: "15px",
      left: "-15px",
      position: "absolute",
      borderRight: `2px solid ${SLOT_PASS_COLORS.EXPIRED}`
    },
    "&:before": {
      content: "''",
      width: " 25px",
      height: "25px",
      bottom: "-12px",
      borderRadius: "15px",
      backgroundColor: "rgb(238,238,238)",
      right: "-15px",
      position: "absolute",
      borderLeft: `2px solid ${SLOT_PASS_COLORS.EXPIRED}`
    }
  },
  lower: {
    // backgroundColor: "#fff",

    padding: "20px",
    borderRadius: "10px"
  },
  font: { fontWeight: 500 },
  large: {
    fontWeight: 600,
    fontSize: "1.125rem"
  },
  qrContainer: {
    padding: "10% 15% 5px"
  },
  subContent: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "inherit"
  },
  entryTiming: {
    fontWeight: "bold",
    fontSize: "16px",
    color: "inherit"
  },
  Active: {
    backgroundColor: SLOT_PASS_COLORS.ACIVE,
    color: "white"
  },
  Boarding: {
    backgroundColor: SLOT_PASS_COLORS.BOARDING,
    color: "white"
  },
  Expired: {
    backgroundColor: SLOT_PASS_COLORS.EXPIRED,
    color: "white"
  },
  Upcoming: {
    backgroundColor: SLOT_PASS_COLORS.UPCOMING,
    color: "black"
  },
  btnStyles: {
    width: "90%",
    margin: "auto",
    borderRadius: "10px"
  }
};

const qrStyle = {
  Boarding: {
    bgColor: SLOT_PASS_COLORS.BOARDING,
    fgColor: "#fff",
    size: 175
  },
  Expired: {
    fgColor: SLOT_PASS_COLORS.EXPIRED,
    size: 175
  },
  Active: {
    fgColor: SLOT_PASS_COLORS.ACIVE,
    size: 175
  },
  Upcoming: {
    size: 175
  }
};

class CafePass extends React.Component {
  constructor(props) {
    super(props);
    const data = props.slotDetails;
    this.state = {
      passStatus: "",
      // locationState,
      data
    };
    this.interval = "";
  }

  getEntryTiming = (start_time, end_time) => {
    const { classes } = this.props;

    return `${GET_12HR_TIME_FORMAT(start_time)} - ${GET_12HR_TIME_FORMAT(
      end_time
    )}`;
  };

  getCustomTimeForCurrentDay = (timeString = "") => {
    let date = new Date();
    let [hours, minutes] = timeString.split(":");
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(0);

    return date;
  };

  checkForTimings = (startTime, endTime, exitTime) => {
    let startTimeObj = this.getCustomTimeForCurrentDay(startTime);
    let endTimeObj = this.getCustomTimeForCurrentDay(endTime);
    let exitTimeObj = this.getCustomTimeForCurrentDay(exitTime);
    let currentTimeObj = new Date();

    if (isBefore(currentTimeObj, startTimeObj)) {
      return "Upcoming";
    } else if (isAfter(currentTimeObj, exitTime)) {
      return "Expired";
    } else {
      if (
        isWithinInterval(currentTimeObj, {
          start: startTimeObj,
          end: endTimeObj
        })
      ) {
        return "Boarding";
      } else if (isAfter(currentTimeObj, exitTimeObj)) {
        return "Expired";
      } else {
        if (
          isWithinInterval(currentTimeObj, {
            start: endTimeObj,
            end: exitTimeObj
          })
        ) {
          return "Active";
        } else {
          return "Expired";
        }
      }
    }
  };

  checkForBookingDate = timestamp => {
    let bookingDate = format(
      timestamp.split(" ")[0].split("-").reverse().join("-"),
      "dd-MM-yyyy"
    );
    bookingDate = parse(bookingDate, "dd-MM-yyyy", new Date());
    let currentDay = format(new Date(), "dd-MM-yyyy");
    currentDay = parse(currentDay, "dd-MM-yyyy", new Date());

    let isCurrentDay = isSameDay(bookingDate, currentDay);
    let isBeforeDay = isBefore(bookingDate, currentDay);
    let isAfterDay = isAfter(bookingDate, currentDay);

    if (isCurrentDay) {
      return "currentDay";
    } else if (isBeforeDay) {
      return "previousDay";
    } else if (isAfterDay) {
      return "nextDay";
    }
  };

  getPassStatus = (tStamp, startTime, endTime, exitTime) => {
    let bookingDateStatus = this.checkForBookingDate(tStamp);
    let currentStatus = "";
    switch (bookingDateStatus) {
      case "currentDay":
        return (currentStatus = this.checkForTimings(
          startTime,
          endTime,
          exitTime
        ));
      case "previousDay":
        return (currentStatus = "Expired");
      case "nextDay":
        return (currentStatus = "Upcoming");
      default:
        return currentStatus;
    }
  };

  componentDidMount() {
    const { data = {} } = this.state;
    const { timestamp, start_time, end_time, exit_by } = data;

    let initialStatus = this.getPassStatus(
      timestamp,
      start_time,
      end_time,
      exit_by
    );
    this.setState({ passStatus: initialStatus });
    this.interval = setInterval(() => {
      let currentStatus = this.getPassStatus(
        timestamp,
        start_time,
        end_time,
        exit_by
      );
      if (this.state.passStatus !== currentStatus) {
        this.setState({ passStatus: currentStatus });
      }
    }, 1000);
  }

  getFormattedDate = timestamp => {
    const { classes } = this.props;

    let [date, time] = timestamp.split(" ");
    let formattedDateString = date.split("-").reverse().join("-");
    formattedDateString = format(formattedDateString, "dd MMM, yyyy");

    return (
      <Typography className={classes.subContent} variant="body2">
        {formattedDateString}
      </Typography>
    );
  };

  render() {
    const { classes } = this.props;
    // const data = location.state.data || {};
    const { data = {} } = this.state;

    const { passStatus } = this.state;

    // let passStatusContent = passStatus;
    // if (passStatus === "Boarding") {
    //   passStatusContent = (
    //     <CountdownTimer countDownTo={data.end_time} fontSize="20px" />
    //   );
    // } else if (passStatus === "Active") {
    //   passStatusContent = GET_12HR_TIME_FORMAT(data.exit_by);
    // }
    let passStatusContent = `Entry Time: \n${this.getEntryTiming(
      data.start_time,
      data.end_time
    )}`;
    if (passStatus === "Expired") {
      passStatusContent = "Expired";
    } else if (passStatus === "Active") {
      passStatusContent = `Exit By: ${GET_12HR_TIME_FORMAT(data.exit_by)}`;
    } else if (passStatus === "Upcoming") {
      passStatusContent = "Upcoming";
    }

    // let passStatusTitle = "";
    // if (passStatus === "Boarding") {
    //   passStatusTitle = "Remaining";
    // } else if (passStatus === "Active") {
    //   passStatusTitle = "Exit By";
    // }
    let passStatusTitle = "";

    let borderColor = "",
      imgSource = "",
      pseudoColorClass = "";
    switch (passStatus) {
      case "Upcoming":
        pseudoColorClass = "upcomingUpper";
        imgSource = UpcomingImage;
        borderColor = SLOT_PASS_COLORS.UPCOMING;
        break;
      case "Boarding":
        pseudoColorClass = "boardingUpper";
        imgSource = BoardingImage;
        borderColor = SLOT_PASS_COLORS.BOARDING;
        break;
      case "Active":
        pseudoColorClass = "activeUpper";
        imgSource = ActiveImage;
        borderColor = SLOT_PASS_COLORS.ACIVE;
        break;
      case "Expired":
        pseudoColorClass = "expiredUpper";
        imgSource = ExpiredImage;
        borderColor = SLOT_PASS_COLORS.EXPIRED;
        break;
      default:
        return null;
    }

    return (
      <React.Fragment>
        <AppBarAndDrawer hideSearchBar={true} />
        <div className={classes.container}>
          <Grid
            container
            item
            className={classes.container}
            style={{
              color: passStatus === "Upcoming" ? "black" : "white"
            }}
          >
            <Grid
              container
              spacing={2}
              direction="column"
              alignItems="center"
              className={classes[pseudoColorClass]}
              style={{
                backgroundColor: borderColor
              }}
            >
              <Grid item md={12}>
                {this.getFormattedDate(data.timestamp)}
              </Grid>
              {(passStatus === "Active" || passStatus === "Boarding") && (
                <Grid item md={12} style={{ padding: "5px" }}>
                  <img src={hourglassWhite} alt="" width="auto" height="50px" />
                </Grid>
              )}
              <Grid item md={12}>
                <Typography
                  variant="body2"
                  color="inherit"
                  style={{ fontSize: "18px", fontWeight: "bold" }}
                >
                  {data.foodcourt || ""}
                </Typography>
              </Grid>
            </Grid>
            {/* <Grid
              container
              item
              className={classes[pseudoColorClass]}
              direction="column"
              style={{
                backgroundColor: borderColor
              }}
            >
              <Grid container item justify="center" alignItems="center">
                {!(passStatus === "Boarding" || passStatus === "Active") ? (
                  <Typography
                    variant="body1"
                    className={classes.font}
                    color="inherit"
                  >
                    Café Entry Pass
                  </Typography>
                ) : (
                  <img src={hourglassWhite} alt="" width="20%"></img>
                )}
              </Grid>
              <Grid
                container
                item
                justify="space-between"
                alignItems="center"
                wrap="nowrap"
                className={classes.marginTop}
              >
                <Grid container item direction="column">
                  <Typography variant="caption" color="inherit">
                    Café
                  </Typography>
                  <Typography
                    variant="body1"
                    className={classes.subContent}
                    color="inherit"
                  >
                    {data.foodcourt || ""}
                  </Typography>
                </Grid>
                <Grid container item direction="column">
                  <Typography variant="caption" align="right" color="inherit">
                    Date
                  </Typography>
                  <Typography
                    variant="body1"
                    align="right"
                    className={classes.large}
                    color="inherit"
                  >
                    {this.getFormattedDate(data.timestamp)}
                  </Typography>
                </Grid>
              </Grid>
            </Grid> */}
            <Grid
              container
              item
              className={classes.lower}
              direction="column"
              style={{
                backgroundColor: "rgb(238, 238, 238)",
                border: `2px solid ${borderColor}`,
                borderTop: "none"
              }}
            >
              <Grid container item justify="center" alignItems="center">
                <Typography
                  variant="body1"
                  className={classes.font}
                  style={{ fontSize: "20px" }}
                >
                  {passStatus === "Boarding" ? "Remaining" : "Entry Time"}
                </Typography>
              </Grid>
              <Grid container item justify="center" alignItems="center">
                <Typography
                  variant="body1"
                  className={classes.font}
                  style={{
                    fontSize: "24px"
                  }}
                >
                  {passStatus === "Boarding" ? (
                    <CountdownTimer
                      countDownTo={data.end_time}
                      fontSize="20px"
                    />
                  ) : (
                    this.getEntryTiming(data.start_time, data.end_time)
                  )}
                </Typography>
              </Grid>
              <Grid
                container
                item
                justify="center"
                alignItems="center"
                className={classes.qrContainer}
              >
                {/* <QR
                  value={data.qrcode}
                  level="L"
                  {...qrStyle[passStatus || "Upcoming"]}
                ></QR> */}
                <img
                  src={imgSource}
                  alt="serving-image"
                  height="100px"
                  width="auto"
                />
              </Grid>
              <Grid container item justify="center" alignItems="center">
                <Typography
                  variant="subheading"
                  style={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    paddingBottom: "30px",
                    opacity: "0.8"
                  }}
                >
                  {passStatus === "Expired"
                    ? "Stay Safe!"
                    : "Have a Happy Meal!"}
                </Typography>
              </Grid>

              <Grid container item justify="center" alignItems="center">
                <Typography variant="body1" className={classes.font}>
                  {passStatusTitle}
                </Typography>
              </Grid>
              <Grid container item justify="center" alignItems="center">
                <Typography
                  variant="body1"
                  className={classes.font}
                  // color="inherit"
                  style={{
                    fontSize: passStatus === "Boarding" ? "18px" : "24px",
                    fontWeight: "bold",
                    whiteSpace: "pre-line",
                    textAlign: "center"
                  }}
                >
                  {passStatusContent}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <div style={{ width: "100%", textAlign: "center" }}>
            <Button
              variant="contained"
              className={`${classes.btnStyles} ${classes[passStatus]}`}
              onClick={() => this.props.history.goBack()}
            >
              CLOSE
            </Button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    slotDetails: state.slotDisplay || {}
  };
};

export default withRouter(
  connect(mapStateToProps, null)(withStyles(styles)(CafePass))
);



// WEBPACK FOOTER //
// ./src/pages/CafePass.js